<template>
  <base-dialog v-bind="$attrs" :showButton="false" :width="width" @handleClose="handleClose">
    <template #title>{{$t('common.download')}}</template>
    <div class="download-warp">
      <div class="download-warp-item" v-for="item in downloadTypeList" :key="item.type">
        <el-image :src="item.imgUrl" :fit="fit" @click="handleDownload(item)">
        </el-image>
        <div class="download-warp-item-type">{{item.name}}</div>
      </div>
    </div>
    <el-divider></el-divider>
    <div class="tips-text">{{$t('warehousingAudit.clickIconDownload')}}</div>
  </base-dialog>
</template>

<script>
import { downloadLink } from '@/utils';
export default {
  name: 'DownloadCorpusDialog',
  props: {
    corpusDetailInfo: {
      type: Object,
      default: () => { }
    },
    bankType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      fit: 'none',
      currentDownloadType: ''
    }
  },
  computed: {
    width() {
      return this.bankType === 'memory' ? '630px' : '450px'
    },
    // 下载类型集合
    downloadTypeList() {
      if (this.bankType === 'memory') {
        return [
          { name: 'XLSX', type: 'xlsx', imgUrl: require('../images/XLSX.png') },
          { name: 'TXT', type: 'txt', imgUrl: require('../images/TXT.png') },
          { name: 'DOC', type: 'doc', imgUrl: require('../images/DOC.png') },
          { name: 'DOCX', type: 'docx', imgUrl: require('../images/DOCX.png') },
          { name: 'XLS', type: 'xls', imgUrl: require('../images/XLS.png') },
          { name: 'TMX', type: 'tmx', imgUrl: require('../images/TMX.png') },
        ]
      } else {
        return [
          { name: 'XLSX', type: 'xlsx', imgUrl: require('../images/XLSX.png') },
          { name: 'TXT', type: 'txt', imgUrl: require('../images/TXT.png') },
          { name: 'TBX', type: 'tbx', imgUrl: require('../images/TBX.png') },
        ]
      }
    },
    // 下载接口
    downloadUrl() {
      if (this.bankType === 'memory') {
        return `${this.baseURL}/api/v1/memory/privateExportMemoryLib?id=${this.corpusDetailInfo.id}&type=${this.currentDownloadType}`
      } else {
        return `${this.baseURL}/api/v1/term/privateExportTermLib?id=${this.corpusDetailInfo.id}&type=${this.currentDownloadType}`
      }
    },

  },
  methods: {
    handleDownload({ type }) {
      this.currentDownloadType = type
      downloadLink(this.downloadUrl)
    },
    handleClose() {
      this.$emit('handleClose')
    }
  }

}
</script>

<style lang="less" scoped>
/deep/.el-dialog__footer {
  display: none;
}
/deep/.el-dialog__header .el-dialog__title .split-line {
  width: 88%;
}
/deep/.el-dialog__body {
  position: relative;
  padding: 12px 54px 32px;
  color: #303133;
  .download-warp {
    display: flex;
    justify-content: center;
    .download-warp-item + .download-warp-item {
      margin-left: 16px;
    }
    &-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
    }
  }
  .el-divider--horizontal {
    margin: 28px 0 12px 0;
  }
  .tips-text {
    text-align: left;
    color: #909399;
  }
}
</style>